export default {"src":"/_next/static/media/fiat-ngn.b0616289.svg","height":20,"width":20};